"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    previous: 'Previous',
    next: 'Next',
    moreRows: '+{{count}} more',
    userGreeting: 'Hello, {{user}}!',
    dragFileOrExplore: 'Drag your file or <1>explore</1>',
    dragImageOrExplore: 'Drag your image or <1>explore</1>',
    uploadWrongImage: 'Uploaded the wrong image? <1>Edit here</1>'
  },
  es: {
    previous: 'Anterior',
    next: 'Siguiente',
    moreRows: '+{{count}} más',
    userGreeting: '¡Hola, {{user}}!',
    dragFileOrExplore: 'Arrastra tu archivo o <1>explora</1>',
    dragImageOrExplore: 'Arrastra tu imagen o <1>explora</1>',
    uploadWrongImage: '¿Subiste la imagen incorrecta? <1>Elige otra</1>'
  },
  fr: {
    previous: 'Précédente',
    next: 'Suivante',
    moreRows: '+{{count}} de plus',
    userGreeting: 'Bonjour, {{user}}!',
    dragFileOrExplore: 'Faites glisser votre fichier ou <1>explorez</1>',
    dragImageOrExplore: 'Faites glisser votre image ou <1>explorez</1>',
    uploadWrongImage: 'Vous avez téléchargé la mauvaise image? <1>Modifier ici</1>'
  },
  de: {
    previous: 'Vorherige',
    next: 'Nächste',
    moreRows: '+{{count}} mehr',
    userGreeting: 'Hallo, {{user}}!',
    dragFileOrExplore: 'Ziehen Sie Ihre Datei oder <1>durchsuchen Sie sie</1>',
    dragImageOrExplore: 'Ziehen Sie Ihr Bild oder <1>erkunden Sie</1>',
    uploadWrongImage: 'Falsches Bild hochgeladen? <1>Hier bearbeiten</1>'
  }
};
exports["default"] = _default;